import { useState } from "react";
import logo from "../assets/logo.png"
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="nav-shell sticky-top">
        <nav className="nav-bar">
          <div className="main-wrap nav-inner">
            <div className="nav-left">
              <a className="nav-brand" href="#about">
                <img
                  src={logo}
                  alt="Logo"
                  className="navbar-brand-logo"
                />
              </a>
            </div>

            <div className="nav-centre">
              <p className="nav-title m-0 p-0">Journey with Jones</p>
              <p className="nav-subtitle m-0 p-0 text-muted">
                Talking therapies, a space to discuss wellbeing
              </p>
            </div>

            <div className="nav-right">
              <button
                type="button"
                className="contactBtnPrimary"
                onClick={() => setMenuOpen(true)}
              >
                Menu
              </button>
            </div>
          </div>
        </nav>
      </header>

      <div
        className={`side-menu-overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      <div className={`side-menu ${menuOpen ? "open" : ""}`}>
        <div className="side-menu-top">
          <p className="side-menu-heading m-0">Menu</p>
          <button
            type="button"
            className="side-menu-close"
            onClick={() => setMenuOpen(false)}
          >
            ×
          </button>
        </div>

        <div className="side-menu-links">
          <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
          <a href="#services" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="#approach" onClick={() => setMenuOpen(false)}>Approach</a>
          <a href="#pricing" onClick={() => setMenuOpen(false)}>Pricing</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
        </div>
      </div>
    </>
  );
}